import './ChatItemDetail.less';

import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';
import { useReframe } from 'nike-re-framejs';

import { getTicketWinValue } from '@/mytickets/utils';
import { formatStakeMoney } from '@/betslip/money';
import TicketStateIcon from '@/mytickets/detail/views/TicketStateIcon';
import { accountUserData$ } from '@/account/subs';

const mena = 'EUR';

function ChatTicketDetail({ ticket, selected, onClick, displayCashin }) {
    const ref = useRef(null);
    const { derefSub, subscribe } = useReframe();
    const hasRunningCashin = displayCashin && derefSub(['ticketus/cashin-offer/is-running', ticket.get('ticketId')]);
    const { idZak: customerId } = subscribe(accountUserData$);
    const status = ticket.hash.startsWith('saved') ? 'Saved' : ticket.displayStatus;

    useEffect(() => {
        if (selected && ref.current) {
            ref.current.scrollIntoView();
            window.scrollTo(0, 0);
        }
    }, [selected]);

    return status !== 'ANALYSIS' ? (
        <div
            ref={ref}
            className={clsx('ticket-detail-slider-item', { selected })}
            data-atid="ticket-detail-slider-item"
            onClick={onClick}
        >
            <div className="ticket-detail-slider-item-content">
                <div className="ticket-detail-ticket-state">
                    <div className={'ticket-state-badge status-badge ' + status} />
                    <TicketStateIcon ticket={ticket} />
                </div>
                <div className="item-values">
                    <div className="item-value-win">{formatStakeMoney(ticket, customerId, true)}</div>
                    <div className={'ticket-value-stake ticket-state-value ' + status}>
                        {getTicketWinValue(ticket, mena)}
                    </div>
                </div>
                {hasRunningCashin ? (
                    <div className="ticket-detail-cashin-icon-wrap">
                        <div className="ticket-detail-cashin-icon" />
                    </div>
                ) : null}
            </div>
        </div>
    ) : null;
}
export default ChatTicketDetail;
